export enum Promotion {
  PROMO_CTA_ACTION_CLICK = 'PromotionCtaClickEvent',
  PROMO_CTA_TAG_CLICK = 'PromotionCtaTagClick',
  PROMO_CTA_MORE_INFO_CLICK = 'PromotionCtaMoreInfoClick',
  PROMO_SET_REMINDER_CLICK = 'PromotionCtaSetReminderClick',
}
